
  import { mapState } from 'vuex'

  export default {
    props: {
      content: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        toggled: false,
        label: '',
        logo: '',
        note: '',
        detailed_note: ''
      }
    },
    async mounted() {
      if (this.order.totals.donations) {
        this.toggled = true
      }
      // Add current donation amount to retrieve fields from olo
      await this.$axios({
        method: 'put',
        url: '/api/v2/carts/'+this.order.id+'/donations',
        data: {
          id: this.order.donations[0].id,
          amount: this.order.totals.donations,
        }
      }).then(res => {
        const campaign = res.data.donations[0] || {}
        this.label = campaign.description || ''
        this.logo = campaign.image_path || ''
        this.note = campaign.note || ''
        this.detailed_note = campaign.detailed_note || ''
      }).catch(err => {
        this.$store.commit('setErrors', [err.response.data.message])
      })
    },
    methods: {
      async toggle() {
        this.toggled = !this.toggled
        await this.$axios({
          method: 'put',
          url: '/api/v2/carts/'+this.order.id+'/donations',
          data: {
            // id: '1468', // FOH donation option id
            id: this.order.donations[0].id,
            amount: this.toggled ? this.amount : 0,
          }
        }).then(res => {
          this.validate()
        }).catch(err => {
          this.$store.commit('setErrors', [err.response.data.message])
          this.toggled = false
        })
      },
      async validate() {
        await this.$api.validateOrder()
      },
    },
    computed: {
      ...mapState(['order','location']),
      amount() {
        if (this.order) {
          const total = (this.order.totals.subtotal + this.order.totals.tax + this.order.totals.tip + this.order.totals.handoff - this.order.totals.discount)
          if (total === 0) {
            return 1.00
          }
          let amount = parseFloat((Math.ceil(total) - total).toFixed(2))
          return amount
        }
      },
      linkContent() {
        const content = {
          link: "/foundation",
          text: "Learn more"
        }

        if (this.content?.link?.cached_url) {
          content.link = this.content.link.cached_url
        }

        if (this.content?.link_text) {
          content.text = this.content.link_text
        }

        return content
      }
    }
  }
